/**
 * 定数コード取得部品
 * 引数で受け取ったコードタイプとコード値に該当するコード名を返す
 * @param type コードタイプ
 * @param value コード値
 * @return TkGetCode 定数コード取得部品
 */
export const TkGetCode = (enumObj: {}, value: any): any => {
  const code = Object.entries(enumObj).find(
    (e) => isNaN(Number(e[0])) && e[1] === value
  )?.[0];
  return code !== null && code !== undefined ? code : value;
};

/**
 * 定数コードリスト取得部品
 * 引数で受け取ったコードタイプのコード名・コード値のリストを返す
 * @param type コードタイプ
 * @return TkGetCodeList 定数コードリスト取得部品
 */
export const TkGetCodeList = (enumObj: { [key: string]: string }) =>
  Object.entries(enumObj).map(([label, value]) => ({
    value,
    label,
  }));
